import { createFileRoute } from "@tanstack/react-router";
import { ContentPage } from "@/features/marketing/content/content-page";
import { body } from "@/features/marketing/content/pages/help";
import { SEO } from "@/features/marketing/seo";

export const Route = createFileRoute("/_marketing/help/")({
  head: SEO["/help"],
  component: () => <ContentPage path="/help" body={body} />,
});
